module.exports = __webpack_public_path__ + "static/media/h6.7fefd6fd.jpeg";